import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, Divider, TextField } from '@material-ui/core';
import { Delete, ExpandLess, ExpandMore, Timer, UnfoldMore } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useState } from 'react';

export const TimerControl = ({ onUpdate, value, onDelete, isSelected }) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [startTime, setStartTime] = useState(moment().add(1, "day").format());
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        let val = JSON.parse(value);
        setDescription(val.description);
        setTitle(val.title);
        setStartTime(val.startTime);
    }, [value]);


    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;
                            <Timer htmlColor='#CECECE' />
                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Countdown
                        </div>
                    </Box>

                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <div className='w-full'>

                        <TextField
                            placeholder='Label'
                            label="Label"
                            onChange={(e) => {
                                setTitle(e.target.value);
                                onUpdate(
                                    JSON.stringify({
                                        title: e.target.value,
                                        description: description,
                                        startTime: startTime
                                    }));
                            }}
                            variant='outlined'
                            fullWidth
                            className='my-2'
                            margin="dense"
                            value={title}
                        />
                        <TextField
                            placeholder='Title'
                            label='Title'
                            onChange={(e) => {

                                setDescription(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: title,
                                        description: e.target.value,
                                        startTime: startTime
                                    }));
                            }}
                            variant='outlined'
                            fullWidth
                            margin="dense"
                            className='my-2'
                            value={description}
                        />
                        <TextField
                            variant='outlined'
                            fullWidth
                            margin="dense"
                            id="datetime-local"
                            label="Start time"
                            type="datetime-local"
                            value={startTime}
                            inputProps={{
                                min: moment().toISOString().slice(0, 16)
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => {
                                setStartTime(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: title,
                                        description: description,
                                        startTime: e.target.value
                                    }));
                            }}
                        />
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setDescription("");
                            setTitle("");
                            setStartTime(moment().add(1, "day").format())
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
